module.exports = __webpack_public_path__ + "img/0000black_back.0260be90.jpg";